export const ValueListForRules = {
  "DEPARTMENT": "LIST_VALUES-DEPARTMENT",
  "OFFICE": "LIST_VALUES-OFFICE",
  "REC_STATUS": "LIST_VALUES-REC_STATUS",
  "PROFILE_CHANGE_STATUS": "LIST_VALUES-PROFILE_CHANGE_STATUS",
  "EFFECTIVE_DATE": "EFFECTIVE_DATE",
  "LIST_ID": "LIST_VALUES-LIST_ID",
  "DESCRIPTION": "LIST_TYPES-DESCRIPTION",
  "LIST_VALUES": "LIST_VALUES-LIST_VALUES",
  "TIME_STAMP": "TIME_STAMP",
  "UID": "VIRTUAL-UID",
  "PROFILE_UPDATE_PK": "PROFILE_UPDATE_PK",
  "PU_TIME_STAMP": "PU_TIME_STAMP",
  "NOTE": "NOTE"
};
